/**
 * @generated SignedSource<<9b25dbb0fa3beaa824ba06d9d9b6c0f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsIcon_viewer$data = {
  readonly conversations?: {
    readonly metadata: {
      readonly lastUnreadMessageDate: string | null;
    } | null;
  } | null;
  readonly isAutomatedOfferNotificationDisabled: boolean | null;
  readonly " $fragmentType": "NotificationsIcon_viewer";
};
export type NotificationsIcon_viewer$key = {
  readonly " $data"?: NotificationsIcon_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsIcon_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsIcon_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            }
          ],
          "concreteType": "ConversationConnection",
          "kind": "LinkedField",
          "name": "conversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastUnreadMessageDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "conversations(filter:\"showUnreadOnly\")"
        }
      ]
    },
    {
      "alias": "isAutomatedOfferNotificationDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableAutomatedOfferBellNotification"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "650dc7a83096d9485a033d06212388c3";

export default node;
